import React from "react";
import { Bar } from "react-chartjs-2";
import { dataForDayTemplate, dataForLucketTemplate } from "../chartTemplates";
import { STATUS_OPTION_HEX_PALLETE } from "../../../components/buckets/constants";

export function WeekPoints({filteredBuckets}){

    const options1 =  {
        scales: {
            y: {
            beginAtZero: true
            }
        }
    }
    let parentLucketsASPoints = filteredBuckets.reduce((acc,v,i,ar)=>{
        acc[i] = v.weekPoints
        return acc
    },[])
    let parentLuckets = filteredBuckets.filter(l=>!l.parentRowID)
    let labels = parentLuckets.map(l=>l.name)
 
    let backgroundColors = parentLuckets.map(l=>STATUS_OPTION_HEX_PALLETE[l.weekActionStatus])
 

    return <Bar
              type="bar"
              options={options1}
              data={dataForLucketTemplate(parentLucketsASPoints, backgroundColors, labels, "Week Action Points by Lucket")}
              />
}